import { useEffect, useRef } from 'react';

export const useEffectOnce = (callback: Function) => {
    const didRun = useRef(false);

    useEffect(() => {
        if (!didRun.current) {
            callback();
            didRun.current = true;
        }
    });
};
